import { useEffect, useState } from "react";

const DEFAULT_MOBILE_BREAKPOINT = 768;

export const useIsMobile = (breakpoint: number = DEFAULT_MOBILE_BREAKPOINT) => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;

    return window.innerWidth <= breakpoint;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const checkScreenWidth = () => {
      const isMobile = window.innerWidth <= breakpoint;
      setIsMobile(isMobile);
    };

    window.addEventListener("resize", checkScreenWidth);

    checkScreenWidth();

    return () => {
      window.removeEventListener("resize", checkScreenWidth);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isMobile;
};
